import { render, staticRenderFns } from "./IconBoxes.vue?vue&type=template&id=4061b2e0"
import script from "./IconBoxes.vue?vue&type=script&lang=js"
export * from "./IconBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports